type BreakpointKey = "xs" | "sm" | "md" | "lg" | "xl" | "2xl";

export function getBreakpoints(): Record<BreakpointKey, number> {
  const keys: BreakpointKey[] = ["xs", "sm", "md", "lg", "xl", "2xl"];

  const root = document.documentElement;

  const computedStyle = getComputedStyle(root);

  const breakpoints = keys.reduce((acc, key) => {
    const value = computedStyle.getPropertyValue(`--breakpoint-${key}`);

    acc[key] = Number.parseInt(value);
    return acc;
  }, {} as Record<BreakpointKey, number>);

  return breakpoints;
}
